/* eslint-disable react/prop-types */ // TODO: add props
import { Children } from 'react';
import * as DOMPurify from 'dompurify';

export const SafeHTML = ({ children, as = 'div', ...props }) => {
  const Component = as;
  return (
    <Component
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(children) }} // eslint-disable-line react/no-danger
      {...props}
    />
  );
};

SafeHTML.propTypes = {
  children: (props, propName, componentName) => {
    const prop = props[propName];

    // Only accept a single child of string type
    if (Children.count(prop) !== 1 || typeof prop !== 'string') {
      return new Error(
        `'${componentName}' component is only used to wrap a string of html. ie, no other jsx elements...`
      );
    }
  },
};
